import { Component } from '@angular/core';
import { BreadcrumbComponent } from '../breadcrumb/breadcrumb.component';

@Component({
  selector: 'app-terms-and-conditions-page',
  imports: [BreadcrumbComponent],
  templateUrl: './terms-and-conditions-page.component.html',
  styleUrl: './terms-and-conditions-page.component.scss'
})
export class TermsAndConditionsPageComponent {

}
